var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../../framework/base";
import { EditItemLockable } from "../common/editItemLockable";
import { FileAttachment } from "../common/fileAttachment";
import { TaskDataRowCol, SaveTaskDataRowCol } from "./taskDataRowCol";
import { TaskTypeCol, modifyDateField, modifyUserNameField } from "./taskTypeCol";
var TaskDataRow = /** @class */ (function (_super) {
    __extends(TaskDataRow, _super);
    function TaskDataRow(obj) {
        var _this = _super.call(this, obj) || this;
        _this.modifyDate = obj && obj.modifyDate || 0;
        _this.modifyUserCode = obj && obj.modifyUserCode || "";
        _this.modifyUserName = obj && obj.modifyUserName || "";
        _this.modifyUserPicture = obj && obj.modifyUserPicture || "";
        _this.state = obj && obj.state || 0;
        _this.hasAttachments = obj && obj.hasAttachments || false;
        _this.cols = Base.getTypedArray(obj ? obj.cols : null, TaskDataRowCol);
        _this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
        return _this;
    }
    TaskDataRow.prototype.initializeCols = function (taskType) {
        this.cols = TaskDataRowCol.initializeValuesByType(taskType.formCols, this.cols);
    };
    TaskDataRow.prototype.initializeToTaskType = function (taskType, dataCols) {
        if (dataCols === void 0) { dataCols = []; }
        if (Base.isNullOrUndefined(taskType))
            return;
        this.cols = TaskDataRowCol.initializeValuesByType(taskType.formCols, dataCols);
    };
    TaskDataRow.prototype.hasDefaultValues = function (taskType) {
        if (Base.isNullOrUndefined(taskType))
            return true;
        return TaskDataRowCol.hasDefaultValues(taskType.formCols, this.cols);
    };
    TaskDataRow.prototype.matchesToFilter = function (lowFilter, taskType) {
        var lineCols = taskType.lineCols.filter(function (i) { return i.isSaveDataType() && i.isSavedTaskDataField(); });
        var formCols = taskType.formCols.filter(function (i) { return i.isSaveDataType() && i.isSavedTaskDataField(); });
        var _loop_1 = function (lineCol) {
            var formIndex = formCols.findIndex(function (j) { return j.field === lineCol.field; });
            if (formIndex < 0 || formIndex > this_1.cols.length - 1) {
                return "continue";
            }
            var dataIndex = this_1.cols.findIndex(function (i) { return i.field === lineCol.field; });
            if (dataIndex < 0 || dataIndex > this_1.cols.length - 1) {
                return "continue";
            }
            if (this_1.cols[dataIndex].matchesToFilter(lowFilter, formCols[formIndex], this_1.modifyUserName, this_1.modifyDate)) {
                return { value: true };
            }
        };
        var this_1 = this;
        for (var _i = 0, lineCols_1 = lineCols; _i < lineCols_1.length; _i++) {
            var lineCol = lineCols_1[_i];
            var state_1 = _loop_1(lineCol);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return false;
    };
    TaskDataRow.prototype.getTaskDataRowColUiValue = function (field, taskType) {
        var formIndex = taskType.formCols.findIndex(function (i) { return i.field === field; });
        if (formIndex < 0 || formIndex > this.cols.length - 1)
            return "";
        var dataIndex = this.cols.findIndex(function (i) { return i.field === field; });
        if (dataIndex < 0 || dataIndex > this.cols.length - 1)
            return "";
        var col = this.cols[dataIndex];
        return TaskDataRowCol.getTaskDataRowColUiValue(taskType.formCols[formIndex], col.valueStr, col.valueNbr);
    };
    TaskDataRow.prototype.getTaskDataRowColListUiValue = function (field, taskType) {
        if (field.equalIgnoreCase(modifyUserNameField)) {
            return {
                text: this.modifyUserName
            };
        }
        if (field.equalIgnoreCase(modifyDateField)) {
            return {
                text: Base.timeToDateTimeStr(this.modifyDate)
            };
        }
        var formIndex = taskType.formCols.findIndex(function (i) { return i.field === field; });
        if (formIndex < 0 || formIndex > taskType.formCols.length - 1)
            return { text: "" };
        var dataIndex = this.cols.findIndex(function (i) { return i.field === field; });
        if (dataIndex < 0 || dataIndex > this.cols.length - 1)
            return { text: "" };
        return {
            text: this.cols[dataIndex].getTaskDataRowColListUiValue(taskType.formCols[formIndex], this.modifyUserName, this.modifyDate),
            icon: this.cols[dataIndex].icon
        };
    };
    TaskDataRow.prototype.getHash = function () {
        var result = _super.prototype.getHash.call(this);
        for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
            var col = _a[_i];
            result = result + "##" + col.getHash();
        }
        return result;
    };
    TaskDataRow.getHash = function (items) {
        if (!items || items.length < 1)
            return "";
        return Base.joinSuffix(items.map(function (i) { return i.getHash(); }), "#");
    };
    TaskDataRow.sortTaskDataRows = function (rows, taskType) {
        if (Base.isNullOrUndefined(rows) || rows.length < 2 || !taskType || taskType.lineCols.length < 1)
            return;
        var formCols = taskType.formCols.filter(function (i) { return i.isSaveDataType() && i.isSavedTaskDataField(); });
        var modifyUserNameIndex = formCols.length;
        var modifyUserNameTaskTypeCol = new TaskTypeCol();
        modifyUserNameTaskTypeCol.field = modifyUserNameField;
        formCols.push(modifyUserNameTaskTypeCol);
        var modifyDateIndex = formCols.length;
        var modifyDateTaskTypeCol = new TaskTypeCol();
        modifyDateTaskTypeCol.field = modifyDateField;
        formCols.push(modifyDateTaskTypeCol);
        var lineCols = taskType.lineCols.filter(function (i) { return i.isSaveDataType(); });
        var dataColIndexes = [];
        var _loop_2 = function (i) {
            dataColIndexes[i] = formCols.findIndex(function (j) { return j.field.equalIgnoreCase(lineCols[i].field); });
        };
        for (var i = 0; i < lineCols.length; i++) {
            _loop_2(i);
        }
        var sortFunction = function (a, b) {
            for (var i = 0; i < lineCols.length; i++) {
                if (!lineCols[i].defaultSortField)
                    continue;
                var result = 0;
                var formColIndex = dataColIndexes[i];
                if (formColIndex === modifyUserNameIndex) {
                    result = TaskDataRowCol.strCompare(a.modifyUserName, b.modifyUserName, lineCols[i].defaultSortOrderAsc);
                }
                else if (formColIndex === modifyDateIndex) {
                    result = TaskDataRowCol.numCompare(a.modifyDate, b.modifyDate, lineCols[i].defaultSortOrderAsc);
                }
                else {
                    if (formColIndex < 0 || a.cols.length <= formColIndex || b.cols.length <= formColIndex)
                        continue;
                    result = TaskDataRowCol.compareTaskDataRowCols(a.cols[formColIndex], b.cols[formColIndex], formCols[formColIndex], lineCols[i].defaultSortOrderAsc);
                }
                if (result !== 0)
                    return result;
            }
            return 0;
        };
        rows.sort(sortFunction);
    };
    TaskDataRow.sortTaskDataRowsByColumn = function (rows, taskType, column, asc) {
        if (Base.isNullOrUndefined(rows) || rows.length < 2 || !taskType || taskType.lineCols.length < 1)
            return;
        var lineCols = taskType.lineCols.filter(function (i) { return i.isSaveDataType() && i.isSavedTaskDataField(); });
        var formCols = taskType.formCols.filter(function (i) { return i.isSaveDataType() && i.isSavedTaskDataField(); });
        var dataColIndexes = [];
        var _loop_3 = function (i) {
            dataColIndexes[i] = formCols.findIndex(function (j) { return j.field === lineCols[i].field; });
        };
        for (var i = 0; i < lineCols.length; i++) {
            _loop_3(i);
        }
        var sortFunction = function (a, b) {
            for (var i = 0; i < lineCols.length; i++) {
                var formColIndex = dataColIndexes[i];
                if (formColIndex < 0 || a.cols.length <= formColIndex || b.cols.length <= formColIndex || lineCols[i].field !== column)
                    continue;
                var result = TaskDataRowCol.compareTaskDataRowCols(a.cols[formColIndex], b.cols[formColIndex], formCols[formColIndex], asc);
                if (result !== 0)
                    return result;
            }
            return 0;
        };
        rows.sort(sortFunction);
    };
    TaskDataRow.createTaskDataRow = function (cols, attachments) {
        var result = new TaskDataRow();
        result.id = Base.getGuid();
        result.cols = cols.slice(0);
        result.attachments = attachments.slice(0);
        return result;
    };
    TaskDataRow.getDynamicDataRowsFromJsonTaskDataRows = function (rows, typeCols) {
        var result = [];
        for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
            var row = rows_1[_i];
            var resultRow = {};
            var _loop_4 = function (col) {
                var typeCol = typeCols.find(function (i) { return i.field === col.field; });
                if (!typeCol)
                    return "continue";
                resultRow[typeCol.field] = TaskDataRowCol.getTaskDataRowColDbValue(typeCol, col.valueStr, col.valueNbr);
            };
            for (var _a = 0, _b = row.cols; _a < _b.length; _a++) {
                var col = _b[_a];
                _loop_4(col);
            }
            result.push(resultRow);
        }
        return result;
    };
    return TaskDataRow;
}(EditItemLockable));
export { TaskDataRow };
var SaveTaskDataRow = /** @class */ (function () {
    function SaveTaskDataRow() {
    }
    SaveTaskDataRow.createSaveTaskDataRow = function (formCols, taskDataRow, cols) {
        var result = new SaveTaskDataRow();
        result.id = taskDataRow.id || "";
        result.rowId = taskDataRow.rowId || "";
        result.cols = [];
        var savedCols = TaskDataRowCol.getToBeSavedTaskDataRowCols(formCols, cols || taskDataRow.cols || []);
        for (var _i = 0, savedCols_1 = savedCols; _i < savedCols_1.length; _i++) {
            var col = savedCols_1[_i];
            result.cols.push(new SaveTaskDataRowCol(col));
        }
        return result;
    };
    return SaveTaskDataRow;
}());
export { SaveTaskDataRow };
